import { CategoryTypes, CategoryActionTypes } from "./categoryTypes";
import { CategoryResponse } from "@/main/models/response";

export function getCategory(isCanastaBasica: boolean = true): CategoryActionTypes {
	return {
		type: CategoryTypes.GET_CATEGORY,
		payload: { isCanastaBasica },
	};
}

export function saveCategory(
	data: CategoryResponse[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): CategoryActionTypes {
	return {
		type: CategoryTypes.SAVE_CATEGORY,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerCategory(): CategoryActionTypes {
	return {
		type: CategoryTypes.RESET_REDUCER_CATEGORY,
	};
}
